import { Box, Typography } from '@mui/material';
import { CommonComponentProps } from '../pages/types';
import EditableMarkdownText from './editable-markdown-text';

interface TitleParagraphProps extends CommonComponentProps {
  title: string;
  paragraph: string;
}

const TitleParagraph: React.FC<TitleParagraphProps> = ({
  title,
  paragraph,
  isEditable,
  onPropsChange,
}) => {
  const handleTextChange = (key: keyof TitleParagraphProps, value: string) => {
    if (onPropsChange) {
      onPropsChange({ [key]: value });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        paddingTop: '16px',
        maxWidth: 1100,
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', sm: '28%' },
          padding: { xs: '16px 16px 0px 16px', sm: '16px 0 0px 20px' },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'top',
          textAlign: 'left',
        }}
      >
        <EditableMarkdownText
          content={title}
          onSave={(val) => handleTextChange('title', val)}
          isEditable={!!isEditable}
          component={Typography}
          typographyVariant="h4"
          componentProp="h4"
          sx={{ cursor: isEditable ? 'text' : 'inherit' }}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          padding: '16px',
          paddingTop: { xs: '8px', sm: '16px' },
        }}
      >
        <EditableMarkdownText
          content={paragraph}
          onSave={(val) => handleTextChange('paragraph', val)}
          isEditable={!!isEditable}
          component={Typography}
          typographyVariant="body1"
          componentProp="p"
          sx={{ cursor: isEditable ? 'text' : 'inherit' }}
        />
      </Box>
    </Box>
  );
};

export default TitleParagraph;
